import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import { rootRoute } from '@/app/routes/root'

import { meQueryOptions } from '@/shared/auth/session'

import { safeRedirect } from './redirect'

const loginSearchSchema = z.object({
  redirect: z.string().optional(),
  expired: z.boolean().optional(),
})

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  validateSearch: (search) => loginSearchSchema.parse(search),
  beforeLoad: async ({ context, search }) => {
    const admin = await context.queryClient.ensureQueryData(meQueryOptions).catch(() => null)

    if (admin) {
      throw redirect({ href: safeRedirect(search.redirect) })
    }
  },
  component: lazyRouteComponent(() => import('./pages/login-page'), 'LoginPage'),
})

export const forgotPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/forgot-password',
  component: lazyRouteComponent(() => import('./pages/forgot-password-page'), 'ForgotPasswordPage'),
})

// O router converte valores numéricos da URL (ex.: invite=1); coerce volta tudo a texto.
const resetSearchSchema = z.object({
  token: z.coerce.string().optional(),
  email: z.coerce.string().optional(),
  invite: z.coerce.string().optional(),
})

/** Destino do link enviado por e-mail (`TenantUrl::to('/reset-password', ...)` na API). */
export const resetPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/reset-password',
  validateSearch: (search) => resetSearchSchema.parse(search),
  component: lazyRouteComponent(() => import('./pages/reset-password-page'), 'ResetPasswordPage'),
})
